import Vue from 'vue';
import "./fonts/iconfont.css"

    import { slice } from "../../../src/filters"

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
import {
  Menu,
  MenuItem,
  Carousel,
  CarouselItem,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Submenu,
  Drawer,
  MessageBox
} from "element-ui"

const initMenuBanners = {
  "ANALYSIS-DASHBOARD-WARNING-ANALYSIS": {
    default: "menu_actionrecord_warning_analysis.svg",
    hover: "menu_actionrecord_warning_analysis_hover.svg"
  },
  "COMMENT-RECORD-DETAILS": {
    default: "menu_textanalysis_evaluationmanagement.svg",
    hover: "menu_textanalysis_evaluationmanagement_hover.svg"
  },
  "WARNING-RECORD-DETAILS": {
    default: "menu_actionrecord_warningrecord.svg",
    hover: "menu_actionrecord_warningrecord_hover.svg"
  },
  "TEXT-ANALYSIS-EVALUATION-MANAGEMENT": {
    default: "menu_textanalysis_evaluationmanagement.svg",
    hover: "menu_textanalysis_evaluationmanagement_hover.svg"
  }, // 文本分析-评价管理
  "ACTION-RECORD-WARNING-ANALYSIS": {
    default: "menu_actionrecord_warning_analysis.svg",
    hover: "menu_actionrecord_warning_analysis_hover.svg"
  }, // 行动记录-预警分析
  "ACTION-RECORD-WARNING-RULES": {
    default: "menu_actionrecord_warningrules.svg",
    hover: "menu_actionrecord_warningrules_hover.svg"
  }, // 行动记录-预警规则
  "ACTION-RECORD-WARNING-RECORD": {
    default: "menu_actionrecord_warningrecord.svg",
    hover: "menu_actionrecord_warningrecord_hover.svg"
  },
  // 住中语音-客诉记录
  "WARNING-SYSTEM-WARNING-RECORD": {
    default: "submenus/normal/WARNING-SYSTEM-WARNING-RECORD.svg",
    hover: "submenus/active/WARNING-SYSTEM-WARNING-RECORD.svg"
  }, // 行动记录-预警记录
  "DATA-CENTER-SURVEY-DATA": {
    default: "menu_datacenter_surveydata.svg",
    hover: "menu_datacenter_surveydata_hover.svg"
  }, // 数据中心-问卷
  "DATA-CENTER-FILE-DATA": {
    default: "menu_datacenter_filedata.svg",
    hover: "menu_datacenter_filedata_hover.svg"
  }, // 数据中心-文件
  "DATA-CENTER-MERGED-CELL-DATA": {
    default: "menu_datacenter_mergedcelldata.svg",
    hover: "menu_datacenter_mergedcelldata_hover.svg"
  }, // 数据中心-合表
  "DATA-CENTER-SOCIAL-DATA": {
    default: "menu_datacenter_socialdata.svg",
    hover: "menu_datacenter_socialdata_hover.svg"
  }, // 数据中心-社交媒体
  "DATA-CENTER-VOICE-DATA": {
    default: "menu_datacenter_voicedata.svg",
    hover: "menu_datacenter_voicedata_hover.svg"
  },
  // 住中语音-语音分析
  "VOICE-ANALYSIS-INDEX": {
    default: "submenus/normal/VOICE-ANALYSIS-INDEX.svg",
    hover: "submenus/active/VOICE-ANALYSIS-INDEX.svg"
  }, // 数据中心-语音
  "DATA-CENTER-IM-DATA": {
    default: "menu_datacenter_imdata.svg",
    hover: "menu_datacenter_imdata_hover.svg"
  }, // 数据中心-IM
  "DATA-CENTER-INTEGRATED-DATA": {
    default: "menu_datacenter_integrateddata.svg",
    hover: "menu_datacenter_integrateddata_hover.svg"
  }, // 行动记录-预警分析
  "ACTION-RECORD-TICKETS-ANALYSIS": {
    default: "menu_actionrecord_tickets_analysis.svg",
    hover: "menu_actionrecord_tickets_analysis_hover.svg"
  },
  // 住中语音-客诉分析
  "WARNING-SYSTEM-WARNING-ANALYSIS": {
    default: "submenus/normal/WARNING-SYSTEM-WARNING-ANALYSIS.svg",
    hover: "submenus/active/WARNING-SYSTEM-WARNING-ANALYSIS.svg"
  }, // 客诉预警-预警分析
  "WARNING-SYSTEMT-WAENING-ANALYSIS": {
    default: "menu_actionrecord_tickets_analysis.svg",
    hover: "menu_actionrecord_tickets_analysis_hover.svg"
  },
  // 4x详情-语音详情
  "VOICE-RECORD-DETAILS": {
    default: "submenus/normal/VOICE-ANALYSIS-DEMAND-DETAIL.svg",
    hover: "submenus/active/VOICE-ANALYSIS-DEMAND-DETAIL.svg"
  },
  // 住中语音-语音记录
  "VOICE-ANALYSIS-DEMAND-DETAIL": {
    default: "submenus/normal/VOICE-ANALYSIS-DEMAND-DETAIL.svg",
    hover: "submenus/active/VOICE-ANALYSIS-DEMAND-DETAIL.svg"
  }, // 行动记录-工单分析
  "WORK-ORDER-LIST": {
    default: "menu_work_order_list.svg",
    hover: "menu_work_order_list_hover.svg"
  }, // 行动记录-全部工单
  "ALL-WORK-ORDER-LIST": {
    default: "menu_work_order_list.svg",
    hover: "menu_work_order_list_hover.svg"
  }, // 行动记录-我的工单
  "MY-WORK-ORDER-LIST": {
    default: "menu_my_work_order_list.svg",
    hover: "menu_my_work_order_list_hover.svg"
  }, // 配置中心-数据源
  "CONFIGURATION-CENTER": {
    default: "menu_configuration_center_data.svg",
    hover: "menu_configuration_center_data_hover.svg"
  }, // 配置中心-数据源
  "CONFIGURATION-CENTER-DATA": {
    default: "menu_configuration_center_data.svg",
    hover: "menu_configuration_center_data_hover.svg"
  }, // 配置中心-数据源
  "CONFIGURATION-CENTER-DATA-LIST": {
    default: "menu_configuration_center_data.svg",
    hover: "menu_configuration_center_data_hover.svg"
  }, // 配置中心-数据看板
  "CONFIGURATION-CENTER-BOARD": {
    default: "menu_configuration_center_board.svg",
    hover: "menu_configuration_center_board_hover.svg"
  }, // 配置中心-自定义词典
  "CONFIGURATION-CENTER-DICTIONARY": {
    default: "menu_configuration_center_custom_dictionary.svg",
    hover: "menu_configuration_center_custom_dictionary_hover.svg"
  }, // 配置中心-机器人通知
  "CONFIGURATION-CENTER-ROBOT-NOTIFICATION": {
    default: "menu_configuration_cente_rrobot_notification.svg",
    hover: "menu_configuration_cente_rrobot_notification_hover.svg"
  }, // 配置中心-通知中心
  "CONFIGURATION-NOTIFICATION-TASK-LIST-INDEX": {
    default: "menu_configuration_center_notifytask_list.svg",
    hover: "menu_configuration_center_notifytask_list_hover.svg"
  }, // 配置中心-成员管理
  "CONFIGURATION-CENTER-MEMBERS-MANAGEMENT": {
    default: "menu_members-management.svg",
    hover: "menu_members-management_hover.svg"
  }, // 配置中心-竟对管理
  "CONFIGURATION-CENTER-TELEPHONE-MANAGEMENT": {
    default: "menu_telephone-management.svg",
    hover: "menu_telephone-management_hover.svg"
  }, // 配置中心-通讯录管理
  "CONFIGURATION-CENTER-COMPETITION-MANAGEMENT": {
    default: "menu_configuration_center_competition_management.svg",
    hover: "menu_configuration_center_competition_management_hover.svg"
  }, // 点评-点评分析
  "COMMENT-ANALYSIS-INDEX": {
    default: "menu_comment_analysis_index.svg",
    hover: "menu_comment_analysis_index_hover.svg"
  }, // 点评-点评管理
  "COMMENT-ANALYSIS-LIST": {
    default: "menu_comment_analysis_list.svg",
    hover: "menu_comment_analysis_list_hover.svg"
  }, // 点评-竞争分析
  "COMMENT-ANALYSIS-COMPETE": {
    default: "menu_comment_analysis_compete.svg",
    hover: "menu_comment_analysis_compete_hover.svg"
  }, // 首页-智能质检
  "QUALITY-INSPECTION-INDEX": {
    default: "menu_quality_inspection_index.svg",
    hover: "menu_quality_inspection_index_hover.svg"
  }, // 首页-数据看板
  "DASHBOARD-INDEX": {
    default: "menu_configuration_center_board.svg",
    hover: "menu_configuration_center_board_hover.svg"
  }, // 服务质检-服务概览
  "SERVICE-OVERVIEW": {
    default: "menu_service_overview.svg",
    hover: "menu_service_overview_hover.svg"
  }, // 服务质检-商圈/竞对质检
  "SERVICE-QUALITY-COMPARE": {
    default: "menu_service_quality_compare.svg",
    hover: "menu_service_quality_compare_hover.svg"
  }, // 服务质检-部门质检
  "DEPARTMENT-QUALITY": {
    default: "menu_service_quality_department_quality.svg",
    hover: "menu_service_quality_department_quality_hover.svg"
  }, // 服务质检-运营周报
  "WEEKLY-REPORT": {
    default: "menu_weekly_report.svg",
    hover: "menu_weekly_report_hover.svg"
  }, // 质量微循环-检查表管理
  "QMS-CHECK-LIST-MANAGE": {
    default: "menu_qms_check_list_manage.svg",
    hover: "menu_qms_check_list_manage_hover.svg"
  }, // 质量微循环-任务看板
  "QMS-TASK-DASHBOARD": {
    default: "menu_qms_task_dashboard.svg",
    hover: "menu_qms_task_dashboard_hover.svg"
  }, // 质量微循环-操作日志
  "QMS-OPRATE-LOG": {
    default: "menu_qms_oprate_log.svg",
    hover: "menu_qms_oprate_log_hover.svg"
  },
  // QMS-酒店自检任务PC
  "QMS-SELF-CHECK-TASK-LIST-PC": {
    default: "menu_inspection_task_list_normal.svg",
    hover: "menu_inspection_task_list_hover.svg"
  },
  // QMS-自检整改任务PC
  "QMS-RECTIFICATION-TASK-LIST-PC": {
    default: "menu_rectification_task_list_normal.svg",
    hover: "menu_rectification_task_list_hover.svg"
  },
  // CEM 商圈热度
  "BUSINESS-CIRCLE-HEAT": {
    default: "menu_market_heat.svg",
    hover: "menu_market_heat_hover.svg"
  },
  // CEM 调价看板
  "REPORTS-MARKET-ANALYSIS": {
    default: "menu_market_price.svg",
    hover: "menu_market_price_hover.svg"
  },
  // 热门话题
  "DATA-CENTER-HOT-TOPIC": {
    default: "menu_hottopic.svg",
    hover: "menu_hottopic_hover.svg"
  },
  // 考核指标
  "CONFIGURATION-CENTER-ASSESSMENT-INDICATORS": {
    default: "submenus/normal/CONFIGURATION-CENTER-ASSESSMENT-INDICATORS.svg",
    hover: "submenus/active/CONFIGURATION-CENTER-ASSESSMENT-INDICATORS.svg"
  },
  // 自定义客诉级别
  "CONFIGURATION-CENTER-COMPLAINTS-LEVEL": {
    default: "submenus/normal/CONFIGURATION-CENTER-COMPLAINTS-LEVEL.svg",
    hover: "submenus/active/CONFIGURATION-CENTER-COMPLAINTS-LEVEL.svg"
  },
  // 华客分管理
  "COMMENT-ANALYSIS-VOCUST-SCORE": {
    default: "submenus/normal/COMMENT-ANALYSIS-VOCUST-SCORE.svg?v=1",
    hover: "submenus/active/COMMENT-ANALYSIS-VOCUST-SCORE.svg?v=1"
  },
  // 单店操作排名
  "HOTEL-ACTION-RANK-LOG": {
    default: "submenus/normal/HOTEL-ACTION-RANK-LOG.svg",
    hover: "submenus/active/HOTEL-ACTION-RANK-LOG.svg"
  },
  // 帐号登陆排名
  "HOTEL-LOGIN-RANK-LOG": {
    default: "submenus/normal/HOTEL-LOGIN-RANK-LOG.svg",
    hover: "submenus/active/HOTEL-LOGIN-RANK-LOG.svg"
  },
  // 报表中心
  "DATA-CENTER-REPORT-CENTER": {
    default: "submenus/normal/DATA-CENTER-REPORT-CENTER.svg",
    hover: "submenus/active/DATA-CENTER-REPORT-CENTER.svg"
  },
  // 4x通知中心
  "CONFIGURATION-CENTER-NOTIFICATION-CENTER": {
    default: "submenus/normal/CONFIGURATION-CENTER-NOTIFICATION-CENTER.svg",
    hover: "submenus/active/CONFIGURATION-CENTER-NOTIFICATION-CENTER.svg"
  },
  // 客户中心
  "CUSTOMER-CENTER": {
    default: "menu_customer_center.svg",
    hover: "menu_customer_center_hover.svg"
  },
  // 自定义标签
  "TAGS-MANAGE": {
    default: "menu_customer_tag.svg",
    hover: "menu_customer_tag_hover.svg"
  }
}

const initMenuIntroductions = {
  "ANALYSIS-DASHBOARD": {
    banner: "menu_dashboard.svg"
  },
  "RECORD-DETAILS": {
    banner: "menu_textanalysis.svg"
  },
  "CUSTOMIZED-DASHBOARD-INDEX": {
    banner: "menu_dashboard.svg"
  },
  "DATA-CENTER-INDEX": {
    banner: "menu_datacenter.svg"
  },
  "TEXT-ANALYSIS-INDEX": {
    banner: "menu_textanalysis.svg"
  },
  "ACTION-RECORD-INDEX": {
    banner: "menu_actionrecord.svg"
  },
  "ACTION-RECORD": {
    banner: "menu_actionrecord.svg"
  },
  "WARNING-SYSLYSIS-INDEX": {
    banner: "menus/WARNING-SYSLYSIS-INDEX.svg"
  },
  "CONFIGURATION-CENTER-INDEX": {
    banner: "menu_configuration.svg"
  },
  "VOICE-ANALYSIS": {
    banner: "menu_voice.svg"
  },
  "COMMENT-ANALYSIS": {
    banner: "menu_comment.svg"
  },
  "HOME-INDEX": {
    banner: "menu_home_index.svg"
  },
  "SERVICE-QUALITY-INDEX": {
    banner: "menu_service_quality_index.svg"
  },
  "QMS-QUALITY-LOOP": {
    banner: "menu_qms_quality_loop.svg"
  },
  "MARKET-ANALYSIS": {
    banner: "menu_dashboard.svg"
  },
  "HOTEL-ACTION-MANAGE": {
    banner: "menus/HOTEL-ACTION-MANAGE.svg"
  },
  "CUSTOMER-MANAGE": {
    banner: "menu_customer_manage.svg"
  }
}

export default {
  components: {
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [Submenu.name]: Submenu,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [DropdownItem.name]: DropdownItem
  },
  props: {
    menus: {
      default: []
    },
    user: {
      default: {}
    },
    IMBaseUrl: {
      default: ""
    },
    ENV: {
      default: "dev"
    },
    logoutUrl: {
      default: ""
    },
    appName: {
      default: "xreports"
    },
    badgeCount: {
      default: null
    }
  },
  filters: {
    slice
  },
  data() {
    return {
      defaultActivedMenu: "",
      drawer: false,
      currentMenu: {},
      brandStyles: {},
      currentRoute: {},
      iconCount: 0,
      device: "pc",
      IM_BASEURL: {
        dev: "https://im-fat.vocustcloud.com?generateKey=BemQMQYlfES2auforI9qlMtVQ3RXkT/zc1J2EU6zYh/VdbKXPTQurQ==",
        fat: "https://im-fat.vocustcloud.com?generateKey=BemQMQYlfES2auforI9qlMtVQ3RXkT/zc1J2EU6zYh/VdbKXPTQurQ==",
        fort: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg==",
        prod: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg==",
        uat: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg=="
      },
      REDIRECT_CASURL: {
        dev: "https://login-fat.vocust.com",
        fat: "https://login-fat.vocust.com",
        fort: "https://login.vocust.com",
        prod: "https://login.vocust.com",
        uat: "https://login-uat.vocust.com"
      },
      curSelectedParentPath: "",
      menuIntroductions: {
        "RECORD-DETAILS": {
          title: $t("e6a250894a04db4c"),
          desc: $t("8bc1785cb7e61665"),
          style: { width: "399px" }
        },
        "ANALYSIS-DASHBOARD": {
          title: $t("8f25571b6140639f"),
          desc: $t("c935c1d59ee52208"),
          style: { width: "399px" }
        },
        "CUSTOMIZED-DASHBOARD-INDEX": {
          title: "Dashboard",
          desc: $t("8a723a5ad03fbef7"),
          style: { width: "399px" }
        },
        "DATA-CENTER-INDEX": {
          title: $t("79f45f61305a0694"),
          desc: $t("82adf873c2aef782"),
          style: { width: "399px" }
        },
        "TEXT-ANALYSIS-INDEX": {
          title: $t("cd613ea5c3daa178"),
          desc: $t("2bcd2acb33ab9226"),
          style: { width: "399px" }
        },
        "ACTION-RECORD-INDEX": {
          title: $t("2c7ee80c60ede727"),
          desc: $t("58f6db165d04ad25"),
          style: { width: "399px" }
        },
        "ACTION-RECORD": {
          title: $t("0df7926026e8e4e3"),
          desc: $t("58f6db165d04ad25"),
          style: { width: "399px" }
        },
        "WARNING-SYSLYSIS-INDEX": {
          title: $t("ae1d807fd0454199"),
          desc: $t("4a225c64927330be"),
          style: { width: "399px" }
        },
        "MARKET-ANALYSIS": {
          title: $t("80ca7ecf9313ef17"),
          desc: $t("803f12f69cd31b8c"),
          style: { width: "399px" }
        },
        "CONFIGURATION-CENTER-INDEX": {
          title: $t("2bc8f2a83dcff037"),
          desc: $t("16ffc39911362949"),
          style: { width: "399px" }
        },
        "VOICE-ANALYSIS": {
          title: $t("c5bda3e67870893b"),
          desc: $t("ee34d8dc6f215415"),
          style: { width: "399px" }
        },
        "COMMENT-ANALYSIS": {
          title: $t("5da3515674304897"),
          desc: $t("a3c01440cba1fd06"),
          style: { width: "399px" }
        },
        "HOME-INDEX": {
          title: $t("f6e62f9642018cbb"),
          desc: $t("65754b79e7c41c2e"),
          style: { width: "399px" }
        },
        "SERVICE-QUALITY-INDEX": {
          title: $t("1c4cb97f3f9338d2"),
          desc: $t("b52df67306a35e1e"),
          style: { width: "399px" }
        },
        "QMS-QUALITY-LOOP": {
          title: $t("877baf13a06ce174"),
          desc: $t("e1c9ff1d345d58c5"),
          style: { width: "399px" }
        },
        "HOTEL-ACTION-MANAGE": {
          title: $t("5e1466065999ca19"),
          desc: $t("37b469bf39d0fdd2"),
          style: { width: "399px" }
        },
        "CUSTOMER-MANAGE": {
          title: $t("f4c19062aa935c68"),
          desc: $t("cd82b93f3e8f252b"),
          style: { width: "399px" }
        }
      },
      menuBanners: {},
      brandLogo: "",
      brandLogoWhite: "",
      matchedCustomerLogo: false
    }
  },
  computed: {
    cdnUrl() {
      if (this.ENV === "prod") {
        return "https://cdn-sv.vocustcloud.com/webres/commonlibs"
      } else {
        return "https://xm-fat.cemsmart.com/commonlibs"
      }
    },
    imgPrefix() {
      return this.cdnUrl + "/common-images/voc-ui/header-menu/"
    }
  },
  watch: {
    "user.tenantId": {
      handler(newVal) {
        if (["479640"].includes(newVal)) {
          this.brandStyles = { height: "auto", width: "110px" }
        }
        if (["315430", "334886"].includes(newVal)) {
          this.brandLogo = `${this.imgPrefix}brand_shangmei_logo.png`
          this.matchedCustomerLogo = true
        } else if (["866529", "940263"].includes(newVal)) {
          // 唯品会
          this.brandLogo = `${this.imgPrefix}brand_weipinhui_logo.png`
          this.matchedCustomerLogo = true
        } else if (["479640"].includes(newVal)) {
          // CITC
          this.brandLogo = `${this.imgPrefix}brand_citc_logo.png`
          this.matchedCustomerLogo = true
        } else {
          this.brandLogo = `${this.imgPrefix}voc_brand_logo.png`
          this.brandLogoWhite = `${this.imgPrefix}voc_brand_logo_white.png`
        }
      },
      immediate: true
    },
    $route: {
      handler() {
        this.defaultActivedMenu = this.$route.name
        this.currentMenu = {}
        this.findCurrentMenu(this.menus)
      },
      deep: true,
      immediate: true
    },
    menus: {
      async handler(newVal) {
        this.iconCount = 0
        for (let index = 0; index < newVal.length; index++) {
          const menu = newVal[index]
          this.loadIcon({
            type: "banner",
            key: menu.code
          })

          if (menu.children && menu.children.length > 0) {
            for (let childIndex = 0; childIndex < menu.children.length; childIndex++) {
              const child = menu.children[childIndex]
              this.loadIcon({
                type: "child",
                key: child.code
              })
            }
          }
        }
        this.findCurrentMenu(newVal)
        if (newVal?.length) {
          this.calcMenuWidth && this.calcMenuWidth()
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (/mobile/i.test(navigator.userAgent)) {
      this.device = "mobile"
    }
  },
  methods: {
    loadIcon({ type, key }) {
      if (type === "banner" && initMenuIntroductions[key]) {
        this.$set(this.menuIntroductions, key, {
          ...this.menuIntroductions[key],
          banner: `${this.imgPrefix}${initMenuIntroductions[key].banner}`
        })
      } else if (type === "child" && initMenuBanners[key]) {
        this.$set(this.menuBanners, key, {
          default: `${this.imgPrefix}${initMenuBanners[key].default}`,
          hover: `${this.imgPrefix}${initMenuBanners[key].hover}`
        })
      }
    },
    onChangeLanguage(language) {
      const originalLanguage = this.$root._$lang || this.$root.$root.lang
      localStorage.setItem("VOC-LANGUAGE", language)
      if (originalLanguage !== language) location.reload()
    },
    getRouteName(route) {
      const lang = this.$lang
      if (lang === "en" && route.alias) return route.alias
      else return route.name
    },
    findCurrentMenu(menus = [], parentMenu = {}) {
      const that = this
      const { $route } = this
      menus.forEach(item => {
        if (item.code === $route.name || item.path === $route.path) {
          that.currentMenu = Object.assign({}, item)
          that.currentMenu.parentMenu = parentMenu
          that.currentMenu.parentName = parentMenu.code
        }
        if (item.children && item.children.length > 0) this.findCurrentMenu(item.children, item)
      })
    },
    drawerOpen() {
      if (this.$refs.carousel) this.$refs.carousel.setActiveItem(0)
      if (this.currentRoute.path) this.$refs.carouselMenu.close(this.currentRoute.path)
    },
    carouselBack() {
      this.$refs.carouselMenu.close(this.currentRoute.path)
      this.$refs.carousel.prev()
    },
    onDrawerMenuSelect(path) {
      console.log(path)
      let route = null
      this.menus.some(item => {
        if (item.path === path) {
          route = item
          return true
        }
      })
      this.currentRoute = route
      this.$refs.carousel.next()
    },
    onMenuSelect(item) {
      const { path } = item
      this.curSelectedParentPath = path
      this.drawer = false
      this.$emit("menuClick", item)
      this.$forceUpdate()
    },
    navClick(item, parent) {
      this.curSelectedParentPath = parent.path
      this.$forceUpdate()
      this.$emit("menuClick", item)
      this.drawer = false
    },
    onSelectApplication() {
      const language = localStorage.getItem("VOC-LANGUAGE")
      window.open(`${this.REDIRECT_CASURL[this.ENV]}${language === "en" ? "/en-US" : ""}/#/system-select`, "_self")
    },
    onCallIM() {
      const { user } = this
      window.open(`${this.IM_BASEURL[this.ENV]}&agentUid=${user.userId}&nickname=${user.userName}`)
    },
    onLogout() {
      console.log(this.logoutUrl)
      MessageBox.confirm($t("aa7e6c204c751cfa"), $t("daaaeb1b7b22b126"), {
        confirmButtonText: $t("204ffab8a6e01870"),
        cancelButtonText: $t("4b3340f7872b411f"),
        type: "warning"
      })
        .then(() => {
          if (this.logoutUrl) {
            window.location.href = `${this.logoutUrl}${
              this.logoutUrl.indexOf("?") !== -1 ? "&" : "?"
            }back=${encodeURIComponent(location.href)}`
          } else {
            this.$router.push({
              path: "/system/logout",
              query: {
                back: encodeURIComponent(location.href)
              }
            })
          }
        })
        .catch(() => {})
    },
    goPage(path) {
      window.location.href = `${window.location.origin}/${this.appName}${path}`
    }
  }
}
